import React from 'react';
import PropTypes from 'prop-types';

import StyledPopup from './StyledPopup';
import PopupContent from './PopupContent';
import PopupBackDrop from './PopupBackDrop';
import PopupBtn from './PopupBtn';

export class Popup extends React.PureComponent {
  state = {
    visible: false,
  };

  handlePopupBtnClick = () => {
    this.setState(prevState => ({ visible: !prevState.visible }));
  }

  handleCloseCLick = () => {
    this.setState({ visible: false });
  }

  handleOnBackdropClick = (e) => {
    if (e.target !== e.currentTarget) return;

    this.props.onClickOnBackdrop();
  }

  render() {
    let content;
    if (this.props.isControlled) {
      content = this.props.isVisible && (
        <React.Fragment>
          <PopupBackDrop onClick={this.handleOnBackdropClick} />
          <PopupContent>
            {this.props.children}
          </PopupContent>
        </React.Fragment>
      );
    } else {
      content = (
        <React.Fragment>
          <PopupBtn onClick={this.handlePopupBtnClick} style={this.props.btnStyles}>{this.props.btnSign}</PopupBtn>
          {this.state.visible && (
            <React.Fragment>
              <PopupBackDrop onClick={this.handleCloseCLick} />
              <PopupContent>
                {this.props.children}
              </PopupContent>
            </React.Fragment>
          )}
        </React.Fragment>
      );
    }
    return (
      <StyledPopup>
        {content}
      </StyledPopup>
    );
  }
}

Popup.propTypes = {
  isControlled: PropTypes.bool,
  isVisible: PropTypes.bool,
  btnSign: PropTypes.string,
  btnStyles: PropTypes.shape(),
  children: PropTypes.node,
  onClickOnBackdrop: PropTypes.func,
};

Popup.defaultProps = {
  isControlled: false,
  isVisible: false,
  btnSign: 'Popup button',
  btnStyles: {},
  children: null,
  onClickOnBackdrop: () => {},
};

export default Popup;
